import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type useAuthStore = {
    isAuthenticated: boolean;
    setAuthenticated: (isAuthenticated: boolean) => void;

    authedUser: object | any;
    setAuthedUser: (user: object | any) => void;

    validationFailed: boolean;
    setValidationFailed: (validationFailed: boolean) => void;
}

export const useAuthStore = create(
    persist<useAuthStore>((set, get) => (
        {
            isAuthenticated: false,
            setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),

            authedUser: {},
            setAuthedUser: (user) => set({ authedUser: user }),

            validationFailed: false,
            setValidationFailed: (validationFailed) => set({ validationFailed }),
        }
    ), {
        name: 'userAuth',
        storage: createJSONStorage(() => sessionStorage),
    })
);